export default __webpack_public_path__ + "static/cd-presentation_by-95eceb798f45696e646b53f6d1e5c97f.png";